TS.ns('WL');

WL.partnerIncomeSourcesModel = new Class({
    Extends: TS.domain.EditDomain,
     
    initialize: function (config) {
        var me = this;

        me.parent(config);

    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var incomeSourceList = me.getDomainProperty('dgPartnerIncomeSources_Property');

        if (incomeSourceList != null) {
            incomeSourceList.on('cellValueChanged', me.onIncomeSourceSelect);
        }
    },

    onIncomeSourceSelect: function (e) { 
        var me = this,
            rec = e.item,
            owner = me._getOwner(),
            incomeSourceList = owner.getDomainProperty('dgPartnerIncomeSources_Property');

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'IsSelected') {
            owner.performServerCommand({
                cmd: 'SelectIncomeSource',
                submitModel: true,
                extraData: {
                    IsSelected: incomeSourceList.SelectedItem().IsSelected(),
                    UID: incomeSourceList.SelectedItem().UID()
                },
                blockUI: true
            });
        }
    }
});